// Common Material Design icon names (without Md prefix)
// Used by AmenityIcon with dynamic Md{name} lookup
// Use search in the admin panel to find icons
export const MATERIAL_ICONS = [
  "AcUnit", "AccessAlarm", "AccessTime", "Accessibility", "AccountBalance",
  "AccountCircle", "Adb", "Add", "AddCircle", "AddShoppingCart",
  "Air", "AirlineSeatFlat", "AirplanemodeActive", "Airplay", "Alarm", "Album",
  "Anchor", "Android", "Announcement", "Apps", "Archive", "ArrowBack", "ArrowDownward",
  "ArrowForward", "ArrowUpward", "ArtTrack", "AspectRatio", "Assessment", "Assignment",
  "AttachMoney", "Audiotrack", "AutoAwesome", "Autorenew", "Backpack", "Backup",
  "Bathroom", "Bathtub", "BatteryFull", "BeachAccess", "Bed", "Beenhere",
  "BikeScooter", "Blender", "Block", "Bluetooth", "Book", "Bookmark", "Build",
  "Building", "Business", "Cable", "Cake", "Calculate", "CalendarMonth", "CalendarToday",
  "Call", "Camera", "CameraAlt", "Campaign", "Cancel", "CardGiftcard", "CardMembership",
  "CardTravel", "Cast", "Category", "Celebration", "Chair", "Check", "CheckCircle",
  "Checkroom", "ChevronLeft", "ChevronRight", "ChildCare", "ChildFriendly", "Circle",
  "CleanHands", "CleaningServices", "Close", "Cloud", "CloudUpload", "Code", "Coffee",
  "Collections", "Comment", "Computer", "ConfirmationNumber", "Construction",
  "ContactPhone", "Contactless", "Contrast", "Cookie", "Copyright", "CreditCard",
  "Crib", "DarkMode", "Dashboard", "DataUsage", "DateRange", "Deck", "Delete",
  "DeliveryDining", "DesignServices", "DesktopMac", "DesktopWindows", "Devices",
  "Diamond", "Directions", "DirectionsBike", "DirectionsBus", "DirectionsCar",
  "DirectionsRun", "DirectionsWalk", "Diversity1", "Diversity2", "Diversity3",
  "Dns", "DoNotTouch", "DoorBack", "DoorFront", "DoorSliding", "Download",
  "Drafts", "Dry", "DryCleaning", "Edit", "Eject", "ElectricBolt", "ElectricCar",
  "Elevator", "Email", "Emergency", "EmojiEvents", "EmojiPeople", "EmojiTransportation",
  "Engineering", "EnhancedEncryption", "Equalizer", "Error", "Escalator",
  "Euro", "Event", "EventSeat", "ExitToApp", "Expand", "Explore", "Extension",
  "Face", "FamilyRestroom", "Fastfood", "Favorite", "Fax", "FeaturedPlayList",
  "Feed", "Fence", "Festival", "FilterList", "FindInPage", "FindReplace",
  "Fingerprint", "FireExtinguisher", "Fireplace", "FirstAid", "Fitbit",
  "FitnessCenter", "Flag", "FlashOn", "Flight", "Flip", "Flood", "Folder",
  "FoodBank", "Forest", "FormatListBulleted", "FormatQuote", "Forum", "Forward",
  "FreeBreakfast", "Fullscreen", "Gamepad", "Garage", "GasMeter", "Gavel",
  "Gesture", "Gif", "Gite", "Glass", "GolfCourse", "Google", "GppBad",
  "GppGood", "Gradient", "Grass", "Grid3x3", "Grid4x4", "GridGoldenratio",
  "GridOn", "GridView", "Group", "GroupAdd", "Groups", "Handshake",
  "Headphones", "HealthAndSafety", "Hearing", "HeartBroken", "Help",
  "HideSource", "Highlight", "History", "Hive", "Home", "HomeRepairService",
  "Hotel", "HourglassFull", "House", "HowToVote", "IceSkating", "Image",
  "ImportContacts", "Info", "Input", "Insights", "IntegrationInstructions",
  "Inventory", "Iron", "Kayaking", "KebabDining", "Key", "Keyboard",
  "KingBed", "Kitchen", "Label", "Lan", "Landscape", "Language", "Laptop",
  "Layers", "Leaderboard", "Light", "LightMode", "Lightbulb", "Link",
  "List", "LiveTv", "LocalActivity", "LocalBar", "LocalCafe", "LocalConvenienceStore",
  "LocalDining", "LocalDrink", "LocalFireDepartment", "LocalFlorist",
  "LocalGasStation", "LocalHospital", "LocalLaundryService", "LocalLibrary",
  "LocalMall", "LocalOffer", "LocalParking", "LocalPharmacy", "LocalPhone",
  "LocalPizza", "LocalPlay", "LocalPolice", "LocalPostOffice", "LocalPrintshop",
  "LocalShipping", "LocalTaxi", "LocationCity", "LocationOn", "Lock",
  "Login", "Logout", "Luggage", "LunchDining",
  "ManageAccounts", "ManageSearch", "Map", "Masks", "Mediation", "MedicalServices",
  "Medication", "MeetingRoom", "Memory", "Menu", "MenuBook", "MenuOpen",
  "Mic", "MiscellaneousServices", "ModeNight", "ModeStandby", "Monitor",
  "MonitorHeart", "Mood", "More", "MoreVert", "Movie", "Moving", "Museum",
  "MusicNote", "MusicVideo", "Nature", "NaturePeople", "NavigateNext",
  "NearMe", "NetworkCheck", "Nightlife", "NoDrinks", "NoFlash", "NoFood",
  "NoMeetingRoom", "NoPhotography", "NoSmoking", "NoStroller", "NordicWalking",
  "North", "Note", "Notifications", "Numbers", "OfflineBolt", "Opacity",
  "Outbond", "Outlet", "OutdoorGrill", "Pages", "Paid", "Panorama",
  "Paragliding", "Park", "Password", "Pause", "Payments", "PedalBike",
  "Pending", "People", "PermIdentity", "PermMedia", "PermScanWifi",
  "Person", "PersonAdd", "PersonPin", "Pets", "Phone", "PhotoAlbum",
  "PhotoCamera", "Piano", "Pin", "PinDrop", "Place", "PlayArrow",
  "PlayCircle", "Plumbing", "Podcasts", "PointOfSale", "Policy", "Poll",
  "Pool", "Power", "PowerSettingsNew", "PrecisionManufacturing", "Print",
  "PrivacyTip", "ProductionQuantityLimits", "Psychology", "Public",
  "Publish", "PushPin", "QrCode", "QuestionAnswer", "QueueMusic",
  "Radar", "Radio", "RamenDining", "RateReview", "Recycling", "ReduceCapacity",
  "Remove", "Reorder", "Replay", "Restaurant", "Restore", "Reviews",
  "RingVolume", "Roofing", "Room", "RoomPreferences", "RoomService",
  "Router", "Rowing", "RssFeed", "Rsvp", "RunningWithErrors", "SafetyCheck",
  "Sanitizer", "Satellite", "Save", "Scanner", "Schedule", "School",
  "Science", "Scoreboard", "ScreenShare", "SdCard", "Search", "Security",
  "Sensors", "SentimentSatisfied", "Settings", "SetMeal", "Share",
  "Shield", "ShoppingBag", "ShoppingBasket", "ShoppingCart", "Shower",
  "SignLanguage", "SignalWifi4Bar", "SimCard", "Skateboarding", "Sledding",
  "SmartButton", "SmartDisplay", "SmartScreen", "Smartphone", "SmokeFree",
  "SmokingRooms", "Sms", "Snooze", "Snowboarding", "Snowmobile", "Soap",
  "SocialDistance", "Sort", "Spa", "SpaceBar", "Speaker", "SpeakerGroup",
  "Speed", "Sports", "SportsBar", "SportsBaseball", "SportsBasketball",
  "SportsCricket", "SportsEsports", "SportsFootball", "SportsGolf",
  "SportsGymnastics", "SportsHandball", "SportsHockey", "SportsKabaddi",
  "SportsMartialArts", "SportsMma", "SportsMotorsports", "SportsRugby",
  "SportsSoccer", "SportsTennis", "SportsVolleyball", "SquareFoot",
  "StackedBarChart", "Star", "Stars", "Store", "Storefront", "Storm",
  "Stroller", "Style", "SubdirectoryArrowLeft", "Subtitles", "Summarize",
  "Support", "Surfing", "SurroundSound", "Swipe", "SwitchAccessShortcut",
  "SwitchAccount", "Sync", "TableBar", "TableRestaurant", "Tablet",
  "Tag", "TapAndPlay", "Task", "TempPreferencesEco", "Terrain",
  "TheaterComedy", "Thermostat", "ThumbUp", "TimeToLeave", "Timer",
  "TireRepair", "Tour", "Toys", "TrackChanges", "Transcribe", "Translate",
  "TravelExplore", "TrendingUp", "TripOrigin", "Tty", "Tv", "Umbrella",
  "Update", "Upgrade", "Usb", "Vaccines", "Verified", "VerifiedUser",
  "Vibration", "VideoCameraFront", "VideoFile", "VideoLibrary", "VideoStable",
  "Videocam", "ViewAgenda", "ViewCarousel", "ViewColumn", "ViewDay",
  "ViewHeadline", "ViewList", "ViewModule", "ViewQuilt", "ViewSidebar",
  "ViewStream", "ViewWeek", "Visibility", "VoiceChat", "VolumeDown",
  "VolumeMute", "VolumeOff", "VolumeUp", "Wallpaper",
  "Warning", "Wash", "Watch", "Water", "WaterDrop", "Waves", "WbCloudy",
  "WbSunny", "WbTwilight", "Web", "Weekend", "Whatsapp", "WheelchairPickup",
  "Wifi", "WifiCalling", "Window", "WineBar", "Work", "WorkspacePremium",
  "Wysiwyg", "Yard", "ZoomIn", "ZoomOut",
];
